module.exports = "<div id=\"visual-container-{{widgetId}}\" style=\"text-align: center;\">\r\n    <img #image [src]=\"deviceImage\" (load)=\"prepareVisual()\" crossorigin=\"anonymous\"/>\r\n    <canvas style=\"\r\n    position: absolute;\r\n    top: 0;\r\n    visibility: hidden;\r\n\"></canvas>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/visual-map/visual-map.component.html
// module id = ../../../../../src/app/shared/components/graphs/visual-map/visual-map.component.html
// module chunks = main